<template>
  <div>
    <accnav
      :list="navList"
      :curTitleId="curTitleId"
      @titleChange="titleChange"
    ></accnav>
    <div>
      <component :is="child"></component>
    </div>
  </div>
</template>

<script>
import accnav from '../../common/accnav.vue'
import special from './children/special.vue'
import exammock from './children/exammock.vue'
export default {
  data: function () {
    return {
      curTitleId: 1, //  1 学习记录   2 我的收藏  3重点课程
      navList: [{
        id: 1,
        name: '专项练习',
      },{
        id: 2,
        name: '模拟考试',
      },{
        id: 3,
        name: '错题本',
      }],
      loading: false,
    }
  },
  computed: {
    child: function () {
      switch (this.curTitleId) {
        case 1:
         return special
         break
        case 2:
         return exammock
         break
      }
    }
  },
  components:{accnav},
  methods:{
    titleChange: function (id) {
      if (id == 3) {
         this.$router.push('/WrongBook')
         return
      }
      this.curTitleId = id
    },
    toCourseDetail: function (id) {
      this.$router.push({
          path : 'CourseDetail',
          query : {id : id},
      })
    }
  },
  mounted: function () {
  }
}
</script>

<style scoped>
  .task_list{
    position: relative;
  }
.task-pagination{
  text-align: center;
  position: absolute;
  bottom: 20px;
  width: 100%;
  left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/AccExam/AccExam.vue